var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.6666 59.9999c0 .7073-.2809 1.3856-.781 1.8857-.5001.5-1.1784.781-1.8856.781h-40c-.7073 0-1.3855-.281-1.8856-.781-.50014-.5001-.78109-1.1784-.78109-1.8857v-55.99997c0-.70725.28095-1.38552.78109-1.88562.5001-.5001 1.1783-.78105 1.8856-.78105h25.5733c.3515-.00098.6998.06755 1.0247.20164s.6201.3311.8686.5797l14.4374 14.4373c.5001.5.7812 1.1782.7813 1.8854z",
    fill: "#d5efdd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.6774 14.6667v-2.6667",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.6774 33.3334v-2.6667",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m26.6667 14.6667h-5.4107c-.8309.0006-1.6356.2903-2.2763.8193-.6406.5291-1.0772 1.2646-1.2349 2.0803-.1576.8158-.0265 1.661.3708 2.3906.3974.7297 1.0363 1.2984 1.8071 1.6085l5.5039 2.2027c.7708.3101 1.4097.8788 1.8071 1.6085.3973.7296.5284 1.5748.3708 2.3906-.1577.8157-.5943 1.5512-1.2349 2.0803-.6407.529-1.4454.8187-2.2763.8192h-5.4267",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m38.6667 1.57349v13.09331c0 .7073.2809 1.3855.781 1.8856s1.1784.7811 1.8857.7811h13.0933",
    fill: "#92d9ad"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.6667 1.57349v13.09331c0 .7073.2809 1.3855.781 1.8856s1.1784.7811 1.8857.7811h13.0933z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5653 44h29.112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.3867 36h13.2907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.6774 28h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5653 52h29.112"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoices);
export default __webpack_public_path__ + "static/media/icon-invoices.d9aba63733bafccb5f2fbb8dcf54599c.svg";
export { ForwardRef as ReactComponent };